export default __webpack_public_path__ + "static/media/nft-marketplace-icon.7f53c818.svg";